import  { useEffect } from "react";
import BreadCrumb from "../Controls/BreadCrumb";
import AdminPackageTypeListItem from "./AdminPackageTypeListItem";
import API from "@src/API.js";

export default function AdminPackageItemTypes(props) {
   const [packageItemTypes, setPackageItemTypes] = useState([]);
   useEffect(() => {
      getData();
   }, []);

   async function getData() {
      const resp = await API.getAsync("/PackageItemTypes");
      if (resp && resp.ok) {
         setPackageItemTypes(resp.jsonData);
      }
   }

   return (
      <div>
         <BreadCrumb props={["Admin", "Master Package Item Types"]} />
         <div className="tabbody">
            <h2>Package Item Types</h2>
            <ul>
               {packageItemTypes.map((a) => {
                  return <AdminPackageTypeListItem key={a.id} packageItemType={a} />;
               })}
            </ul>
         </div>
      </div>
   );
}

